import { WatchlistBackendInterface } from './watchlist.backend-interface';
import { Watchlist } from './watchlist';
import { generateWatchlistElementFromBackendInput } from '../watchlist-element/watchlist-element.generators';
import { environment } from '../../../../environments/environment';


/**
 * Generates a Watchlist based on api input
 *
 * @param input
 * @returns
 */
export const generateWatchlistFromBackendInput = (input: WatchlistBackendInterface): Watchlist => {

  const watchlist: Watchlist = {
    uuid: input.Uuid,
    name: input.Name,
    shared: input.Shared,
    detailsLoaded: false,
    elements: []
  };

  if (input.Comment) {
    watchlist.comment = input.Comment;
  }

  if (input.Sorting) {
    watchlist.sorting = input.Sorting;
  }

  if (input.Created) {
    watchlist.created = input.Created * 1000;
  }

  if (input.LastModified) {
    watchlist.lastModified = input.LastModified * 1000;
  }

  if (input.Products) {
    watchlist.elements = [...watchlist.elements, ...input.Products.map(generateWatchlistElementFromBackendInput)];
  }

  if (input.Suppliers && environment.featureFlags.supplierList) {
    watchlist.elements = [...watchlist.elements, ...input.Suppliers.map(generateWatchlistElementFromBackendInput)];
  }

  if (input.Comparisons && environment.featureFlags.productComparison) {
    watchlist.elements = [...watchlist.elements, ...input.Comparisons.map(generateWatchlistElementFromBackendInput)];
  }

  if (input.Queries) {
    watchlist.elements = [...watchlist.elements, ...input.Queries.map(generateWatchlistElementFromBackendInput)];
  }

  if (input.ProductValidations) {
    watchlist.elements = [...watchlist.elements, ...input.ProductValidations.map(generateWatchlistElementFromBackendInput)];
  }

  if (input.productspecifications) {
    watchlist.elements = [...watchlist.elements, ...input.productspecifications.map(generateWatchlistElementFromBackendInput)];
  }

  if (input.ParentUuid) {
    watchlist.parentUuid = input.ParentUuid;
  }

  return watchlist;
};
